module.exports = __webpack_public_path__ + "static/img/banner2.e5da814.webp";


//////////////////
// WEBPACK FOOTER
// ./static/images2/h5/banner2.webp
// module id = ZNhG
// module chunks = 2